export default ({
  direction,
  metricAlignment = 'center'
}, {
  rhythm
}) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: alignments[metricAlignment],
    flexPack: 'center',
    flexWrap: 'wrap',
    flexDirection: direction === 'vertical' && 'column',
    margin: rhythm(-0.75),

    '& > *': {
      margin: rhythm(0.75)
    }
  }
})

const alignments = {
  stretch: 'space-between',
  even: 'space-around',
  center: 'center'
}



// WEBPACK FOOTER //
// ./components/slices/Metrics/MetricGroup/styles.js